var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "image-upload",
      attrs: {
        id: "image-upload",
        centered: "",
        "footer-class": "flex-nowrap",
        "no-close-on-backdrop": "",
        size: [1, 2].includes(_vm.activeTab) ? "xl" : "md"
      },
      on: { ok: _vm.confirmUpload },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function() {
            return [_c("h3", [_vm._v(_vm._s(_vm.modalTitle))])]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function({ close }) {
            return [
              _c(
                "b-button",
                {
                  staticClass: "p-3 border-right-light-grey",
                  attrs: { block: "" },
                  on: {
                    click: function($event) {
                      return close()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("buttons.cancel")) + " ")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "p-3",
                  attrs: {
                    variant: "primary",
                    block: "",
                    disabled: _vm.computedDisableButton
                  },
                  on: { click: _vm.confirmUpload }
                },
                [_vm._v(" " + _vm._s(_vm.$t("buttons.ok")) + " ")]
              )
            ]
          }
        }
      ])
    },
    [
      !_vm.isSysAdmin
        ? _c(
            "div",
            [
              _c("image-upload", {
                ref: "imageUpload",
                attrs: {
                  "image-object": _vm.imageObjectOfModalWindow,
                  allowFileSizeValidation: _vm.allowFileSizeValidation,
                  acceptedFileTypes: _vm.typeOfUpload,
                  type: _vm.type
                },
                on: {
                  "upload-image-object": _vm.updateUploadImageObject,
                  "disable-modal-ok-button": _vm.disableOkButtonManually,
                  "file-removed": _vm.removeImage
                }
              })
            ],
            1
          )
        : _c(
            "b-tabs",
            {
              staticClass: "mb-3",
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("modals.imageUpload.tabs.upload") } },
                [
                  _c(
                    "div",
                    [
                      _vm.usePersonalization === true
                        ? _c("div", { staticClass: "mx-3 mt-3" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("modals.imageUpload.imageTitle"))
                              )
                            ])
                          ])
                        : _vm._e(),
                      _c("image-upload", {
                        ref: "imageUpload",
                        attrs: {
                          "image-object": _vm.imageObjectOfModalWindow,
                          allowFileSizeValidation: _vm.allowFileSizeValidation,
                          acceptedFileTypes: _vm.typeOfUpload,
                          type: _vm.type
                        },
                        on: {
                          "upload-image-object": _vm.updateUploadImageObject,
                          "disable-modal-ok-button":
                            _vm.disableOkButtonManually,
                          "file-removed": _vm.removeImage
                        }
                      }),
                      _vm.hasPersonalization
                        ? _c("div", { staticClass: "m-3 align-right" }, [
                            _vm.usePersonalization === false
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn green-button-transparent border-0 btn-secondary",
                                    on: {
                                      click: function($event) {
                                        _vm.usePersonalization = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "modals.imageUpload.usePersonalization"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.usePersonalization === true
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn green-button-transparent border-0 btn-secondary",
                                    on: { click: _vm.disablePersonalization }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "modals.imageUpload.disablePersonalization"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.usePersonalization
                        ? _c("div", [
                            _vm.personalizationSetIdArray
                              ? _c(
                                  "div",
                                  { staticClass: "m-3" },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.personalizationSetIdArray
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.valueId = null
                                        }
                                      },
                                      model: {
                                        value: _vm.setId,
                                        callback: function($$v) {
                                          _vm.setId = $$v
                                        },
                                        expression: "setId"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.setId
                              ? _c(
                                  "div",
                                  { staticClass: "m-3" },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.personalizationValueArray
                                      },
                                      on: { change: _vm.updatePersonalization },
                                      model: {
                                        value: _vm.valueId,
                                        callback: function($$v) {
                                          _vm.valueId = $$v
                                        },
                                        expression: "valueId"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("modals.imageUpload.tabs.library") } },
                [
                  _c("div", { staticClass: "p-3" }, [
                    _vm.libraryLoading
                      ? _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("modals.imageUpload.libraryLoading"))
                          )
                        ])
                      : _vm.libraryImages.length === 0
                      ? _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("modals.imageUpload.libraryEmpty"))
                          )
                        ])
                      : _c(
                          "div",
                          [
                            _c(
                              "div",
                              { staticClass: "image-library-grid" },
                              _vm._l(_vm.libraryImages, function(img) {
                                return _c(
                                  "div",
                                  {
                                    key: img.image_id,
                                    class: [
                                      "image-library-item",
                                      {
                                        selected:
                                          _vm.selectedLibraryImageId ===
                                          img.image_id
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.selectLibraryImage(img)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "image-thumb-container" },
                                      [
                                        _c("img", {
                                          staticClass: "img-thumbnail",
                                          attrs: {
                                            src: _vm.cloudImageUrl(img.url),
                                            alt: img.name
                                          }
                                        })
                                      ]
                                    ),
                                    _c("div", { staticClass: "image-name" }, [
                                      _vm._v(_vm._s(img.name))
                                    ])
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm.libraryImages.length > 0 && _vm.totalPages > 1
                              ? _c("b-pagination", {
                                  staticClass: "library-pagination",
                                  attrs: {
                                    "per-page": 1,
                                    "total-rows": _vm.totalPages,
                                    limit: 5,
                                    size: "md"
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.fetchLibraryImages(
                                        true,
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                  ])
                ]
              ),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("modals.imageUpload.tabs.pexels") } },
                [
                  _c(
                    "div",
                    { staticClass: "p-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-3" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "mr-3",
                              attrs: {
                                href: "https://www.pexels.com",
                                target: "_blank"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "https://images.pexels.com/lib/api/pexels.png",
                                  alt: "Pexels",
                                  height: "38"
                                }
                              })
                            ]
                          ),
                          _c(
                            "form",
                            {
                              staticClass: "flex-grow-1",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.searchPexels.apply(null, arguments)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.pexelsQuery,
                                        expression: "pexelsQuery"
                                      }
                                    ],
                                    staticClass: "form-control mr-2",
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "modals.imageUpload.pexelsSearchPlaceholder"
                                      )
                                    },
                                    domProps: { value: _vm.pexelsQuery },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.pexelsQuery = $event.target.value
                                      }
                                    }
                                  }),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "success"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("buttons.search")))]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      ),
                      _vm.pexelsLoading
                        ? _c(
                            "div",
                            { staticClass: "text-center my-4" },
                            [
                              _c("b-spinner", {
                                attrs: { small: "", type: "grow" }
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("modals.imageUpload.pexelsLoading")
                                  ) +
                                  " "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.pexelsError
                        ? _c("div", { staticClass: "text-danger my-2" }, [
                            _vm._v(_vm._s(_vm.pexelsError))
                          ])
                        : _vm._e(),
                      _vm.pexelsImages.length > 0
                        ? _c(
                            "div",
                            { staticClass: "image-library-grid" },
                            _vm._l(_vm.pexelsImages, function(img) {
                              return _c(
                                "div",
                                {
                                  key: img.id,
                                  class: [
                                    "image-library-item",
                                    {
                                      selected:
                                        _vm.selectedPexelsImageId === img.id
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-thumb-container",
                                      attrs: { id: `pexels-img-${img.id}` },
                                      on: {
                                        click: function($event) {
                                          return _vm.uploadPexelsImage(img)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-thumbnail",
                                        attrs: {
                                          src: img.src.medium,
                                          alt: img.alt || "Pexels image"
                                        }
                                      }),
                                      _vm.pexelsUploadingId === img.id
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "pexels-uploading-overlay"
                                            },
                                            [
                                              _c("b-spinner", {
                                                attrs: {
                                                  small: "",
                                                  type: "grow"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        target: `pexels-img-${img.id}`,
                                        triggers: "hover",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "modals.imageUpload.pexelsPhotoBy",
                                              { photographer: img.photographer }
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c("div", { staticClass: "image-name" }, [
                                    _vm._v(_vm._s(img.alt))
                                  ])
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm.pexelsImages.length === 0 &&
                      !_vm.pexelsLoading &&
                      _vm.pexelsQuery
                        ? _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("modals.imageUpload.pexelsNoResults")
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm.pexelsImages.length > 0 && _vm.pexelsTotalPages > 1
                        ? _c("b-pagination", {
                            staticClass: "library-pagination",
                            attrs: {
                              "per-page": 1,
                              "total-rows": _vm.pexelsTotalPages,
                              limit: 5,
                              size: "md"
                            },
                            on: {
                              input: function($event) {
                                return _vm.searchPexels($event)
                              }
                            },
                            model: {
                              value: _vm.pexelsCurrentPage,
                              callback: function($$v) {
                                _vm.pexelsCurrentPage = $$v
                              },
                              expression: "pexelsCurrentPage"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }